// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_2pGoZ","content":"index_content_SgswX","flag":"index_flag_2wmIO","nameOfTheClass":"index_nameOfTheClass_31YJP"};